/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Not_Started_HintInputs */



/**
* | output |
* | --- |
* | "Nothing is wrong, and there is nothing you need to do until then." |
*
* @param {Org_Not_Started_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_not_started_hint = /** @type {((inputs?: Org_Not_Started_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Not_Started_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es liegt kein Fehler vor, und bis dahin ist nichts zu tun.")
	return /** @type {LocalizedString} */ ("Nothing is wrong, and there is nothing you need to do until then.")
});